import { getCurrentSessionId } from 'logger';
import toast from 'react-hot-toast';

import { useMutation } from '@apollo/client';

import { SUBMIT_SUPPORT_REQUEST } from 'mutation/submitSupportRequest';

export const useSubmitSupportRequest = () => {
  const [mutate] = useMutation(SUBMIT_SUPPORT_REQUEST);
  const sessionId = getCurrentSessionId() || '';

  const submitRequest = async (description: string, metadata: Record<string, any> = {}) => {
    try {
      await mutate({
        variables: {
          input: {
            description,
            sessionId,
            url: window.location.href,
            metadata,
          },
        },
      });

      toast.success('Your request was submitted. Thank you!');
      return true;
    } catch (err) {
      console.error('Support request failed:', err);
      toast.error('Something went wrong. Please try again.');
      return false;
    }
  };

  return submitRequest;
};
